// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3Qkkv","left":"StickyBox_left__24N5x","right":"StickyBox_right__1j5pv"};